import { render, staticRenderFns } from "./FirstAid.vue?vue&type=template&id=2037fef3"
import script from "./FirstAid.vue?vue&type=script&lang=js"
export * from "./FirstAid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports